import Vue from "vue"
import { Component, Prop, Emit } from "vue-property-decorator"
import ValidatedFormGroup from "../../Default/common/validated-form-group.vue"
import FormGroupStatic from "./form-group-static.vue"
import { IContractSettings } from "../../new-contract-vuex-store";
import { IProductGroupViewModel, IContractViewModel, IAddressViewModel } from "../../../../../Scripts/inpulse/I4UViewModels";
import { IContactPersonViewModel, ICustomerViewModel, ICompanyViewModel, IMeteringPointViewModel } from "../../../../../Scripts/inpulse/I4UViewModels";
import { InvoicingMethodEnum, CustomerTypeEnum } from "../../../../../Scripts/inpulse/CommonEnums";
import { ValidationErrors } from "../../new-contract-vue";
import ProductSelectionDisplay from "../steps/product-selection-display.vue"
import MeteringPointInformationDisplay from "../steps/metering-point-information-display.vue"
import ContractPartnerCard from "../steps/components/contract-partner-card.vue";
import { GenericTypeFormatTranslator, InvoicingMethodFormat, CommonFormatUtils } from "../../../../../Scripts/inpulse/FormatUtils"
import { TranslateResult } from "vue-i18n"
import { ContactPersonUtils } from "../../../../../Scripts/inpulse/ContactPersonUtils"
import { AddressFormat } from "../../../../../Scripts/inpulse/AddressFormat"
import { NewContractEvents } from "../../new-contract-vue-events";
import LoadingComponent from "@/Scripts/vue-components/common/loading.vue";
import Authentication from "../steps/authentication.vue"

declare let currentLocale: string;
declare let customerCultureCode: string;

declare global {
    interface Window { allowAcceptOfferWithoutHavingAccount: boolean; }
}
window.allowAcceptOfferWithoutHavingAccount = window.allowAcceptOfferWithoutHavingAccount || false; //gets data passed from Offer.cshtml which gets it from TempData via tupasController

@Component({
    components: {
        ValidatedFormGroup,
        FormGroupStatic,
        ContractPartnerCard,
        ProductSelectionDisplay,
        MeteringPointInformationDisplay,
        LoadingIndicator: LoadingComponent, 
        Authentication
    },
})

export default class PhaseContractConfirmation extends Vue {
    get contractSettings(): IContractSettings { return this.$store.state.contractSettings; }
    get isLoading(): boolean { return this.$store.state.loadingNewPhase; }
    get isAuthed(): boolean { return this.$store.state.isUserAuthenticated || window.allowAcceptOfferWithoutHavingAccount; }
    get contract(): IContractViewModel { return this.$store.state.contract; }
    get customer(): ICustomerViewModel { return this.contract.Customer; }
    get company(): ICompanyViewModel { return this.contract.Company; }
    get customerName(): string { return this.$store.getters.customerName; }
    get customerIdentifier(): string { return this.$store.getters.customerIdentifier; }
    get customerPhone(): string { return this.$store.getters.customerPhone; }
    get customerEmail(): string { return this.$store.getters.customerEmail; }
    get customerAddress(): IAddressViewModel { return this.$store.getters.customerAddress; }
    get isInvoicingMethodsInUse(): boolean { return this.contractSettings.InvoicingMethodsInUse; }
    get isAcceptingOffer(): boolean { return this.contract.IsAcceptingOffer }
    get selectedProductGroups(): IProductGroupViewModel[] { return this.$store.state.selectedProduct.ProductGroups; }
    get meteringPoint(): IMeteringPointViewModel { return this.contract.MeteringPoint; }
    get offerId(): string { return this.contract.OfferId; }
    selected: string;

    get contractPartners(): IContactPersonViewModel[] {
        let res = [];
        this.customer.ContractPartners.forEach(x => {
            if (!ContactPersonUtils.isEmpty(x))
                res.push(x);
        });
        return res;
    }
    get contactPersons(): IContactPersonViewModel[] {
        let res = [];
        console.log("get contactPersons()");
        this.company.ContactPersons.forEach(x => {
            if (!ContactPersonUtils.isEmpty(x)) {
                console.log("contactPerson exists");
                res.push(x);
            }
        });
        return res;
    }

    InvoicingMethodEnum: typeof InvoicingMethodEnum = InvoicingMethodEnum;
    CustomerTypeEnum: typeof CustomerTypeEnum = CustomerTypeEnum;

    @Prop({ default: function () { return new ValidationErrors() } })//Default value to initialize new since there won't be ValidationErrors with new offer and validation-id="acceptTerms" needs it to be shown in UI
    public validationErrors: ValidationErrors;

    @Emit()
    public previousPhase() { }

    @Prop()
    public showAuthentication: boolean;

    @Prop({ default: false })
    consumerStrongAuthenticationWhenAcceptingOffer: boolean;

    @Emit()
    authenticate() { }

    @Emit()
    nextPhase() { }

    constructor() {
        super();
    }

    mounted() {
        console.log("Phase contract confirmation!");
    }

    created() {
        //this.setCultureCode()
    }

    get CONameString(): string {
        let tmpCOName = this.contract.IsCustomerAddressInUse == true ? this.contract.CustomerType === this.CustomerTypeEnum.CONSUMER ? this.customer.Address.COName : this.company.Address.COName : "";
        if (tmpCOName !== null && tmpCOName !== "") {
            tmpCOName = "c/o " + tmpCOName;
        }
        return tmpCOName !== null ? tmpCOName : "";
    }

    get customerAddressString(): string {
        if (this.contract.IsCustomerAddressInUse) {
            return AddressFormat.toSingleString(this.customerAddress);
        }
        return this.meteringPointAddressString;
    }

    get meteringPointAddressString() {
        let addr = this.contract.MeteringPoint.Address;
        return AddressFormat.toSingleString(addr);
    }

    invoicingMethodString(type: InvoicingMethodEnum): string | TranslateResult {
        return GenericTypeFormatTranslator.toString(InvoicingMethodFormat.toString, type, this.$i18n);
    }

    get invoicingAddressString(): string {
        let addr = "";
        addr = AddressFormat.toSingleString(this.contract.InvoicingAddress.Address);

        if (this.contract.InvoicingAddress.Address.COName !== null && this.contract.InvoicingAddress.Address.COName !== "") {
            addr = this.contract.InvoicingAddress.Address.COName + ", " + addr;
        }

        if (this.contract.InvoicingAddress.ContactPersonName !== null && this.contract.InvoicingAddress.ContactPersonName !== "") {
            addr = this.contract.InvoicingAddress.ContactPersonName + ", " + addr;
        }

        return addr;
    }

    confirm() {
        console.log("Confirm!");
    }

    formatDate(date: string) {
        return CommonFormatUtils.formatDate(date);
    }

    get isMandatatoryMarketingChannel(): boolean {
        if (this.selectedProductGroups !== null && this.selectedProductGroups.length > 0) {
            const ret = this.selectedProductGroups.find(x => x.Code === "EmailPakollinen");
            if (ret !== null && ret !== undefined) {
                console.log("isMandatatoryMarketingChannel(): true");
                return true;
            }
        }
        return false;
    }

    isPriimaPlus(): boolean {
        return this.contractSettings.PriimaPlusProductId && this.contractSettings.PriimaPlusProductId > 0
            && this.contract.ProductId == this.contractSettings.PriimaPlusProductId;
    }

    //redirect to login page with correct return url to get back to accepting the offer
    handleAuthenticationClick() {
        window.location.href = `/eServices/Online/LoginWithJustTupas?returnUrl=/NewContract/Contract/Offer?id=${this.offerId}`;
        //window.location.href = `/eServices/Tupas/AuthenticationStart?service=optunnistus&returnUrl=/NewContract/Contract/Offer?id=${this.offerId}`;
        return false;
    }
}